import type { Option } from "@tento-lona/sheets";
import type { SheetRow } from "../rows/sheet-row.ts";
import type { EventIdPromotions } from "./event-id-promotions.ts";
import { EventsTable } from "./events-table.ts";

/**
 * The event-id promotions (`EventIdPromotions.Surface`) of the client that owns
 * `row`: found through the events table any row of `row`'s subtree (itself
 * first) is attached to — one table per client, so any attached row names
 * the right one. `null` when no row under it is attached to an events table
 * (it renders no events).
 */
export function eventIdPromotionsOf(
  row: SheetRow.Joined.Handle,
): Option<EventIdPromotions.Surface> {
  const rh = row.joined.rowHandle;
  const table = rh != null ? EventsTable.fromHandle(rh) : null;
  if (table != null) return table.promotions;
  for (const child of row.children()) {
    const found = eventIdPromotionsOf(child);
    if (found != null) return found;
  }
  return null;
}
